/* eslint-disable */
require('./arrow_down')
require('./arrow_left')
require('./arrow_right')
require('./arrow_up')
require('./available')
require('./bell')
require('./box')
require('./building')
require('./bulb')
require('./calendar')
require('./chip')
require('./close')
require('./contacts')
require('./crop')
require('./damage')
require('./dollars')
require('./double_arrow_right')
require('./ecg')
require('./fit')
require('./gallery')
require('./geofence')
require('./help')
require('./history')
require('./inbox')
require('./magnify')
require('./menu')
require('./outbox')
require('./partner')
require('./pin')
require('./plus')
require('./previous')
require('./question')
require('./route')
require('./sales')
require('./settings')
require('./sim')
require('./software')
require('./star')
require('./stats')
require('./tracking')
require('./trash')
require('./truck')
require('./unavailable')
require('./upload')
require('./user')
require('./warehouse')
require('./warning')
